/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetWarehouseIntegrationsHealthQueryParams = NonNullable<
  operations['getWarehouseIntegrationsHealth']['parameters']['query']
>;

export interface Input {
  apiVersion?: string;
  query?: GetWarehouseIntegrationsHealthQueryParams;
}

export async function getWarehouseIntegrationsHealth(
  { apiVersion, query }: Input = {},
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/warehouse-integrations-health', {
    params: { query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
